var render = function () {
  var _vm$currentRound$cont, _vm$currentRound$cont2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'line-by-line'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('figure', {
    attrs: {
      "id": "lbyl-figure"
    }
  }, [_c('img', {
    attrs: {
      "alt": (_vm$currentRound$cont = _vm.currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.description,
      "src": (_vm$currentRound$cont2 = _vm.currentRound.contentImage) === null || _vm$currentRound$cont2 === void 0 ? void 0 : _vm$currentRound$cont2.image.src
    }
  })]), _c('text-display-list', {
    attrs: {
      "text-size": _vm.isMobile ? 'mobileFontSize' : _vm.currentRound.textSize
    }
  }, [_vm.currentRound.optionalTitle ? _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.currentRound.optionalTitle) + "\n        ")]) : _vm._e(), _vm._l(_vm.currentRound.steps, function (step, stepIdx) {
    return _c('li', {
      key: step.answer
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIdx
      }
    })], 1);
  })], 2)], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }